import React from 'react'
import PickSelect from './PickSelect'
import PlayerSelect from './PlayerSelect'
import NumberTeamSelect from './NumberTeamSelect'
import Result from './Result'
import PieChart from './PieChart'

const title = Object.assign({fontFamily: 'Oswald'})
const sent_style = Object.assign({fontFamily: 'Oswald'}, {color: '#ab5b5b'})
const rec_style = Object.assign({fontFamily: 'Oswald'}, {color: '#005b96'})

class InputGrid extends React.Component {
  render () {
    return (
      <div>
        <div className="row">
            <div className="col-md-12 text-center">
                <h2 style={title}>League Settings:</h2>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <NumberTeamSelect how={this.props.updateLeagueSize}/>
              </div>
            </div>
            <div className="col-md-9">
              <div className="form-group">
                <PlayerSelect {...this.props} placeholder="Keepers (OPTIONAL). Normal pick calculator if blank. Enter for league, not just your team." 
                  how={this.props.updatePicksKept}/>
              </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-6 text-center">
              <h2 style={sent_style}>Sent:</h2>
            </div>
            <div className="col-md-6 text-center">
              <h2 style={rec_style}>Recieved:</h2>
            </div>
        </div>
        <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <PickSelect {...this.props} placeholder="Pick(s) sent, e.g. 13 (overall) or 2.1 (round/pick)."
                  how={this.props.updatePicksSent}/>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <PickSelect {...this.props} placeholder="Pick(s) recieved, e.g. 13 (overall) or 2.1 (round/pick)."
                  how={this.props.updatePicksRec}/>
              </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <PlayerSelect {...this.props} placeholder="Player(s) sent."
                  how={this.props.updatePlayersSent}/>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <PlayerSelect {...this.props} placeholder="Player(s) recieved."
                  how={this.props.updatePlayersRec}/>
              </div>
            </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <Result {...this.props} />
          </div>
            <div className="col-md-6">
              <div className="form-group">
                <PieChart {...this.props}
                  rec={this.props.trade.playerRec.concat(this.props.trade.pickRec)} 
                  sent={this.props.trade.playerSent.concat(this.props.trade.pickSent)}
                />
              </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12 text-center">
              <br/>
              <br/>
              <p>Just trading picks? Check out the non-player, <a href="http://www.draftpicktradecalculator.com">draft pick only</a> version!</p>
            </div>
        </div>
      </div>
    )
  }
}

export default InputGrid



// WEBPACK FOOTER //
// ./src/components/InputGrid.js